import moment from 'moment-timezone';
import React from 'react';

import utils from '../../../../services/utils';
import FieldBold from '../../../Fields/FieldBold/FieldBold';
import Tags from '../../../Tags/Tags';

import classes from './InfoPay.module.scss';

const InfoPay = ({ invoice, isProcess }) => {
  return (
    <div className={classes.content}>
      <span className='semibold-18'>Información del pago</span>
      <div className={classes.fields}>
        <FieldBold title='TIPO DE PAGO'>
          <Tags
            text={invoice.totalValueWasPayed ? 'Pago total' : 'Pago parcial'}
            type={invoice.totalValueWasPayed ? 'green' : 'gray'}
          />
        </FieldBold>
        <FieldBold
          title='FECHA Y HORA DE PAGO'
          value={moment(isProcess ? invoice.creationDate : invoice.paymentDate).format('DD/MM/YYYY[,] hh:mm a')}
        />
        <FieldBold title={isProcess ? 'MONTO A PAGAR' : 'MONTO PAGADO'} value={utils.moneyFormat(invoice.payedValue)} />
      </div>
    </div>
  );
};

export default InfoPay;
